import _ from 'lodash';

const supportedJobTypes = ['Submission', 'PolicyChange', 'Cancellation', 'Renewal'];

function getJobDetailUISrefByJobType(type, jobNumber) {
    let uisref = `quote.detail.summary({submissionNumber: "${jobNumber}"})`;

    switch (type) {
        case 'Submission': {
            uisref = `quote.detail.summary({submissionNumber: "${jobNumber}"})`;
            break;
        }
        case 'PolicyChange': {
            uisref = `endorsements.detail.summary({policyChangeNumber: "${jobNumber}"})`;
            break;
        }
        case 'Cancellation': {
            uisref = `cancellation.detail.summary({cancellationNumber: "${jobNumber}"})`;
            break;
        }
        case 'Renewal': {
            uisref = `renewal.detail.summary({renewalNumber: "${jobNumber}"})`;
            break;
        }
        default: {
            break;
        }
    }

    return uisref;
}

function openJobInXCenter(GPA_PC_ENTRY_POINT, jobNumber) {
    window.location.href = `${GPA_PC_ENTRY_POINT}?JobNumber=${jobNumber}`;
}

function isSupportJobType(type) {
    return _.includes(supportedJobTypes, type);
}

export default {
    'getJobDetailUISrefByJobType': (type, jobNumber) => {
        return getJobDetailUISrefByJobType(type, jobNumber);
    },
    'openJobInXCenter': (GPA_PC_ENTRY_POINT, jobNumber) => {
        return openJobInXCenter(GPA_PC_ENTRY_POINT, jobNumber);
    },
    'isSupportJobType': (type) => {
        return isSupportJobType(type);
    }
};
